// extracted by mini-css-extract-plugin
module.exports = {"specials-badge":"specials-badge_specials-badge__fL_IG"};